import { createContext, useContext } from 'react';
import type { ReactNode } from 'react';
import { VmClient } from './client';

export type VmConnectionStatus = 'connecting' | 'ready' | 'error';

interface VmClientContextValue {
  client: VmClient | null;
  status: VmConnectionStatus;
  error: string | null;
  retry: () => void;
}

const VmClientContext = createContext<VmClientContextValue | null>(null);

export function VmClientProvider({
  value,
  children,
}: {
  value: VmClientContextValue;
  children: ReactNode;
}) {
  return <VmClientContext.Provider value={value}>{children}</VmClientContext.Provider>;
}

export function useVmConnection(): VmClientContextValue {
  const ctx = useContext(VmClientContext);
  if (!ctx) throw new Error('useVmConnection must be used within VmClientProvider');
  return ctx;
}

export const useOptionalVmClient = (): VmClient | null => useVmConnection().client;
